import { Map } from 'immutable'
import _ from 'lodash'

import { GENERAL_TABS_ACTIVE_TAB, GENERAL_TABS_REMOVE_DATA } from './constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case GENERAL_TABS_ACTIVE_TAB: {
            const id = _.get(action, 'data.id', null)
            if (!id) return state

            const index = _.get(action, 'data.index', 0)

            return state.setIn([id, 'activeIndex'], index)
        }
        case GENERAL_TABS_REMOVE_DATA: {
            const id = _.get(action, 'data.id', null)
            if (!id) return state

            return state.delete(id)
        }
        default:
            return state
    }
}
